import { ActionCreator } from 'redux';
import { AddErrorMessageAction, ClearDebugMessageListAction, ToggleDebugModeActon } from './type';
import { ADD_CONSOLE_MESSAGE, CLEAR_CONSOLE_MESSAGE, TOGGLE_DEBUG_MODE } from './constant';
import moment = require('moment');

export const toggleDebugMode: ActionCreator<ToggleDebugModeActon> = (isDemoModeActive: boolean) => ({
    type: TOGGLE_DEBUG_MODE,
    payload: {
        isDemoModeActive
    },
});

export const addDebugMessage: ActionCreator<AddErrorMessageAction> = (message: string, isError: boolean, extraInfo?: any) => ({
    type: ADD_CONSOLE_MESSAGE,
    payload: {
        timestamp: moment().toLocaleString(),
        message,
        isError,
        extraInfo: extraInfo ? JSON.stringify(extraInfo, undefined, 2) : ""
    }
})

export const clearDebugMessageList: ActionCreator<ClearDebugMessageListAction> = () => ({
    type: CLEAR_CONSOLE_MESSAGE
})


// WEBPACK FOOTER //
// ./src/store/Utilities/actions.ts